import { Action } from '@ngrx/store';

export class SalesForceAction implements Action {

    public static sendMarketingCampaignsData: string = '[SalesForce] sendMarketingCampaignsData';
    public static sendMarketingCampaignsDataError: string = '[SalesForce] sendMarketingCampaignsDataError';
    public static sendMarketingCampaignsDataSuccess: string = '[SalesForce] sendMarketingCampaignsDataSuccess';

    public static sendUTM: string = '[SalesForce] sendUTM';
    public static sendUTMError: string = '[SalesForce] sendUTMError';
    public static sendUTMSuccess: string = '[SalesForce] sendUTMSuccess';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
